import React from 'react';
import I18n from 'utils/I18n';
import SvgAchievementsTrophyNormalSmall from '@strava/icons/AchievementsTrophyNormalSmall';
import Button from '@strava/ui/Button';
import PropTypes from 'prop-types';
import Cldr from 'utils/Cldr';
import { segAndBestEffortAchievementsProps } from '../../../../props/feed-prop-types';

import styles from '../index.scss';
import { useFeedEntityContext } from '../../../../state/FeedEntityContext';
import { OPEN_MODAL_ACHIEVEMENTS_TAB } from '../../../../state/feed-entity-actions';

//  Segment Effort And Best Effort Achievements Count
const AchievementCount = ({ segAndBestEffortAchievements, entityId }) => {
  const { dispatch } = useFeedEntityContext();

  return (
    <div
      className={`${styles.stat} ${styles.mediaRight} ${styles.textRight} ${
        segAndBestEffortAchievements.length > 0 ? styles.empty : ''
      }`}
      data-testid="achievement_container"
      title={I18n.t('components.feed.social.achievements')}
    >
      <div className={`${styles.statSubtext}`}>
        {I18n.t('components.feed.social.achievements')}
      </div>
      <b className={`${styles.statText} ${styles.trophyCountBtn}`}>
        <Button
          className={styles.achievementsTrophy}
          variant="icon"
          type="button"
          onClick={() =>
            dispatch({
              type: OPEN_MODAL_ACHIEVEMENTS_TAB,
              payload: {
                element: 'achievements_trophy',
                selectedEntityId: entityId
              }
            })
          }
        >
          <span className={styles.appIconWrapper}>
            <span className={styles.iconWrapper}>
              <SvgAchievementsTrophyNormalSmall />
            </span>
          </span>
          <span className={styles.count} data-testid="achievement_count">
            {Cldr.formatDecimal(segAndBestEffortAchievements.length)}
          </span>
        </Button>
      </b>
    </div>
  );
};

AchievementCount.propTypes = {
  segAndBestEffortAchievements: segAndBestEffortAchievementsProps,
  entityId: PropTypes.string.isRequired
};

AchievementCount.defaultProps = {
  segAndBestEffortAchievements: []
};

export default AchievementCount;
